module.exports = __webpack_public_path__ + "static/profile2-0080c59e00e1dd745d5d9eeb0c45099a.png";